import dayjs from 'dayjs';
import utc from "dayjs/plugin/utc";
import localizedFormat from "dayjs/plugin/localizedFormat";
import relativeTime from "dayjs/plugin/relativeTime";
import isToday from "dayjs/plugin/isToday";
import advancedFormat from "dayjs/plugin/advancedFormat";

dayjs.extend(utc);
dayjs.extend(localizedFormat);
dayjs.extend(relativeTime);
dayjs.extend(isToday);
dayjs.extend(advancedFormat);

export const formatDateToShortReadable = (dateString) => {
  const date = new Date(dateString);
  const options = { day: '2-digit', month: 'short', year: 'numeric' };
  return date.toLocaleDateString('en-GB', options);
} 

export const formatDate = (dateString) => {
  if (dateString && validateDate(dateString)) {
    return dayjs(dateString).format('MMM Do YYYY');
  } else return '-';
};

export const validateDate = (date, format)  => {
  const inValidDates = ["0000-00-00", "", null, undefined];
  if (inValidDates.includes(date)) return "";

  const parsed = format
    ? dayjs(date, format, true)
    : dayjs(date);
  return parsed.isValid() ? parsed : "";
};

export const formatChatTimestamp = (utcTimestamp) => {
  if (!utcTimestamp) return "";

  const localTime = dayjs.utc(utcTimestamp).local();

  if (localTime.isToday()) {
    return localTime.format("hh:mm A");
  } else if (localTime.isSame(dayjs().subtract(1, "day"), "day")) {
    return "Yesterday";
  } else {
    return localTime.format("DD/MM/YYYY");
  }
};

export const groupMessagesByDate = (messages, groupMessages) => {
  const result = [...groupMessages];
  let lastDateKey = "";
  if (result.length > 0) {
    const lastGroup = result[result?.length - 1];
    lastDateKey = lastGroup?.date;
  }

  messages.forEach((msg) => {
    const date = dayjs(msg?.sent_at).startOf("day");
    const currentKey = getGroupLabel(date);

    if (currentKey !== lastDateKey) {
      lastDateKey = currentKey;
      result.push({
        date: currentKey,
        messages: [msg],
      });
    } else {
      result[result.length - 1].messages.push(msg);
    }
  });

  return result;
};

const getGroupLabel = (date) => {
  let label = date.format("D MMMM YYYY");
  if (date.isToday()) label = "Today";
  else if (date.isSame(dayjs().subtract(1, "day"), "day")) label = "Yesterday";
  return label;
};
